import { Component } from '@angular/core';

@Component({
  selector: 'app-campus-landing-links',
  templateUrl: './campus-landing-links.component.html',
  styleUrls: ['./campus-landing-links.component.scss']
})
export class CampusLandingLinksComponent {

}
